import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { observable, toJS } from 'mobx'
import { observer, inject } from 'mobx-react'

import { autobind } from 'core-decorators'
import Content from '../../base/components/Content'

import RateForm from '../components/RateForm'

const camelCase = (str) => {
  return str.replace(/-(\S)/g, (all, group1) => {
    return group1.toUpperCase()
  })
}

const getDefaults = () => ({
  museum: {
    id: null
  },
  offeringId: null,
  participate: false,
  acceptDataUsage: false,
  userFirstname: '',
  userLastname: '',
  userStreet: '',
  userZip: '',
  userLocation: '',
  school: '',
  overallImpression: 0,
  didactically: 0,
  presentation: 0,
  spacial: 0,
  win: 0,
  recommendationRate: undefined,
  comment: '',
  wayOfDiscovery: {
    teacher: false,
    musbi: false,
    homepageMusem: false,
    flyerMusem: false,
    press: false,
    collegue: false
  }
})

@inject('rating', 'museum') @observer
export default class RatePage extends Component {

  static propTypes = {
    museum: PropTypes.object.isRequired,
    params: PropTypes.shape({
      cryptoId: PropTypes.string,
      type: PropTypes.string,
    }),
    rating: PropTypes.object.isRequired,
  }

  componentDidMount() {
    this.props.museum.load(null, {
      cryptoId: this.props.params.cryptoId,
      action: 'crypto'
    })
      .then((result) => {
        this.museum = result.models[0]
        this.reset()
      })
  }

  @observable museum = null

  @observable success = false

  @observable message = ''

  @observable formData = getDefaults()

  @autobind
  handleChange({
    target: {
      name, value, type, checked
    }
  }) {

    name = camelCase(name.replace('rating-', ''))
    const keys = name.split('.')
    const lastKey = keys.pop()

    if (type === 'checkbox') {
      value = checked
    }

    const target = keys.reduce((provider, key) => {
      return provider[key]
    }, this.formData)

    if (lastKey && target) {
      target[lastKey] = value
    }
  }

  isComplete() {
    const nameComplete = this.formData.userFirstname.trim()
      && this.formData.userLastname.trim()
    let addressComplete = !this.formData.participate

    if (this.formData.participate) {
      addressComplete = !!(this.formData.userStreet.trim()
        && this.formData.userZip.trim()
        && this.formData.userLocation.trim()
        && this.formData.school.trim())
    }

    const questionsComplete = this.formData.overallImpression !== 0
      && this.formData.didactically !== 0
      && this.formData.presentation !== 0
      && this.formData.spacial !== 0
      && this.formData.win !== 0
      && this.formData.recommendationRate !== 0

    const wayOfDiscoveryComplete = Object.keys(this.formData.wayOfDiscovery)
      .reduce((isValid, key) => isValid || this.formData.wayOfDiscovery[key], false)

    const programComplete = this.formData.offeringId

    const conceedsDataUsage = this.formData.acceptDataUsage

    return programComplete
      && nameComplete
      && addressComplete
      && questionsComplete
      && wayOfDiscoveryComplete
      && conceedsDataUsage
  }

  reset() {
    const cachedMuseum = this.formData.museum.id || this.museum.id
    const cachedProgram = this.formData.offeringId
    this.formData = getDefaults()
    this.message = ''
    this.formData.museum.id = cachedMuseum
    this.formData.offeringId = cachedProgram
  }

  @autobind
  handleSubmit(e) {
    e.preventDefault()
    const data = toJS(this.formData)
    data.museumCryptoId = this.props.params.cryptoId
    data.offeringType = data.offeringId[0] === 'p' ? 'program' : 'guidedTour'
    data.offeringId = parseInt(data.offeringId.replace(/(p|g)/, ''), 10)
    this.props.rating.create(data)
      .then(() => {
        this.reset()
        this.success = true
      })
      .catch((error) => {
        this.message = error.message
      })
  }

  render() {

    const isTeacher = this.props.params.type === 'teacher'

    return (
      <Content>

        <div className="rating-form">
          {!this.success
            ? (
              <form
                className="form form-horizontal clearfix inner"
                onChange={this.handleChange}
                onSubmit={this.handleSubmit}
              >

                {
                  this.museum
                    ? (
                      <RateForm
                        data={this.formData}
                        museum={this.museum}
                        isTeacher={isTeacher}
                      />
                    )
                    : null
                }

                <div className="message help-block">
                  {this.message}
                </div>

                <div className="col-xs-8 col-xs-offset-4">
                  <button
                    type="submit"
                    className="action btn btn-primary pull-right"
                    disabled={!this.isComplete()}
                  >
                    Bewertung abgeben
                  </button>
                </div>

              </form>
            )
            : (<div className="help-block">Vielen Dank für die Bewertung!</div>)}
        </div>

      </Content>
    )

  }
}



// WEBPACK FOOTER //
// ./src/frontend/rating/containers/RatePage.js